import ky from 'ky';
import { useAuthStore } from '../stores/auth';

const api = ky.create({
  prefixUrl: '/api',
  timeout: 30000,
  hooks: {
    beforeRequest: [
      (request) => {
        const token = useAuthStore.getState().token;
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        // 只对已登录用户的请求处理 401（排除登录相关接口）
        if (response.status === 401) {
          const url = _request.url;
          // 登录相关接口返回 401 是正常的错误，不应该触发登出
          if (!url.includes('/auth/login') && !url.includes('/auth/init-admin')) {
            // Token 过期，清除认证状态
            useAuthStore.getState().logout();
            window.location.href = '/login';
          }
        }
        return response;
      },
    ],
  },
});

export default api;
